module.exports = __webpack_public_path__ + "jpmorgan.jpg?542ccbb06108e02633b3463d8fa96754";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/jpmorgan.jpg
// module id = 70
// module chunks = 0